/**
 * homepage-entrance-phase2.js — top-level entry attached via Drupal library.
 *
 * Does cheap eligibility checks synchronously, then lazy-loads the heavy
 * orchestrator (three.js + GSAP) in the next idle window. Keeps the LCP
 * budget clean.
 */

function ready() {
  return document.readyState === 'loading'
    ? new Promise(r => document.addEventListener('DOMContentLoaded', r, {once: true}))
    : Promise.resolve();
}

function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function hasWebGL() {
  try {
    const c = document.createElement('canvas');
    return !!(c.getContext('webgl2') || c.getContext('webgl'));
  } catch (e) {
    return false;
  }
}

async function boot() {
  await ready();

  const root = document.querySelector('[data-phase2-root]');
  if (!root) return;

  // Reduced-motion path boots so we catch bootstrap bugs early; CSS + `inert`
  // keep the animation invisible to the user and keyboard-inaccessible.
  // WebGL absence aborts hard — no point booting an orchestrator that can't render.
  if (!hasWebGL()) return;

  const isMobile = window.matchMedia('(max-width: 992px)').matches;
  const runBoot = async () => {
    try {
      if (isMobile) {
        const mod = await import('./homepage-entrance-phase2/phase2-mobile.js');
        await mod.initPhase2Mobile();
      } else {
        const mod = await import('./homepage-entrance-phase2/phase2.js');
        await mod.initPhase2();
      }
    } catch (err) {
      console.warn('[phase2] orchestrator load failed; fallback remains.', err);
    }
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(runBoot, {timeout: 2000});
  } else {
    setTimeout(runBoot, 0);
  }
}

boot();
